import { aboutContent, contactContent, appContent } from '@/mocks/homeData';

export function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            关于吃瓜群
          </h2>
          <div className="mt-8 space-y-4 text-left">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">{p}</p>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-[540px] mx-auto">
            {aboutContent.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-lg bg-background-50 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>{stat.value}</div>
                <div className="mt-1 text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[640px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            投稿爆料
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">{contactContent.description}</p>

          <div className="mt-8 p-6 rounded-lg bg-background-100 border border-background-200/70">
            <div className="flex items-center justify-center gap-2 text-base text-foreground-700">
              <i className="ri-mail-line text-primary-500"></i>
              <span className="font-medium">{contactContent.email}</span>
            </div>
            <ul className="mt-5 space-y-2 text-left">
              {contactContent.tips.map((tip, i) => (
                <li key={i} className="flex items-start gap-2 text-xs text-foreground-500">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 max-w-[900px] mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              随时随地，掌上吃瓜
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">{appContent.description}</p>
            <ul className="mt-5 space-y-2">
              {appContent.features.map((feat, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-check-line text-primary-500"></i>
                  <span>{feat}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex-shrink-0 w-48 h-64 rounded-2xl bg-background-50 border-2 border-background-300/60 flex items-center justify-center">
            <div className="text-center">
              <i className="ri-smartphone-line text-4xl text-primary-400"></i>
              <p className="mt-2 text-xs text-foreground-400">移动端适配已上线</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}